import { Component } from '@angular/core';
import { GlobalVariables } from 'src/app/data/global-variables';

@Component({
  selector: 'app-access-selection-popup',
  templateUrl: './access-selection-popup.component.html',
  styleUrls: ['./access-selection-popup.component.css']
})
export class AccessSelectionPopupComponent {

  isShowing = false;
  bookUrl: string | null = null;
  visorUrl: string | null = null;
  reportUrl: string | null = null;
  selectedOption: 'book' | 'visor' | null = null;

  get isMobile() {
    return this.globalVariables.isPageSmall;
    //return false;
  }

  constructor(private globalVariables: GlobalVariables) {}

  show(bookUrl: string | null, visorUrl: string | null, reportUrl: string | null) {
    this.bookUrl = bookUrl || null;
    this.visorUrl = visorUrl || null;
    this.reportUrl = reportUrl || null;
    this.selectedOption = null;
    this.isShowing = true;
  }

  hide() {
    this.isShowing = false;
  }

  selectAndGoTo(option: 'book' | 'visor', url: string | null) {
    if (url == null) return;
    this.selectedOption = option;
    setTimeout(() => this.goTo(url), 350);
  }

  goTo(url: string | null) {
    if(url == null) return;

    if (!/^https?:\/\//i.test(url)) {
      url = window.location.protocol + '//' + url;
    }
    
    window.location.href = url;
  }
}

